package org.chiangmeng.qfast.core.domain.usecases

import kotlinx.coroutines.flow.Flow
import org.chiangmeng.qfast.core.domain.models.Shop
import org.chiangmeng.qfast.core.domain.ports.QueueRepository

class ObserveShopUseCase(private val repository: QueueRepository) {
    operator fun invoke(shopId: String): Flow<Shop?> = repository.observeShop(shopId)
}